import gql from 'graphql-tag';

export default gql`
  mutation SetUserFlagMutation($identifier: UserFlagIdentifierType!) {
    me {
      flag {
        set(identifier: $identifier) {
          __typename
          ... on BasicMutationSuccess {
            __typename
          }

          ... on Error {
            code
            name
            description
          }
        }
      }
    }
  }
`;
